import { render, staticRenderFns } from "./StepLayout.vue?vue&type=template&id=b81acc2c&scoped=true"
import script from "./StepLayout.vue?vue&type=script&lang=js"
export * from "./StepLayout.vue?vue&type=script&lang=js"
import style0 from "./StepLayout.vue?vue&type=style&index=0&id=b81acc2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81acc2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b81acc2c')) {
      api.createRecord('b81acc2c', component.options)
    } else {
      api.reload('b81acc2c', component.options)
    }
    module.hot.accept("./StepLayout.vue?vue&type=template&id=b81acc2c&scoped=true", function () {
      api.rerender('b81acc2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/storeVisitReport/components/Step/StepLayout.vue"
export default component.exports